export type CimmplePayDocItem = {
  sourcePath: string;
  routePath: string;
  title: string;
};

export const cimmplePayDocsManifest: CimmplePayDocItem[] = [
  { sourcePath: "README.md", routePath: "", title: "CimmplePay Integration Docs" },
  { sourcePath: "getting-started.md", routePath: "getting-started", title: "Getting Started" },
  { sourcePath: "authentication.md", routePath: "authentication", title: "Authentication" },
  { sourcePath: "core-flows.md", routePath: "core-flows", title: "Core Integration Flows" },
  { sourcePath: "api-quick-reference.md", routePath: "api-quick-reference", title: "API Quick Reference" },
  { sourcePath: "go-live-checklist.md", routePath: "go-live-checklist", title: "Go-Live Checklist" },
  { sourcePath: "reference/README.md", routePath: "reference", title: "API Reference" },
  { sourcePath: "reference/introduction.md", routePath: "reference/introduction", title: "Reference Introduction" },
  { sourcePath: "reference/auth/login.md", routePath: "reference/auth/login", title: "Login" },
  { sourcePath: "reference/auth/switch-company.md", routePath: "reference/auth/switch-company", title: "Switch Company" },
  { sourcePath: "reference/employees/list-employees.md", routePath: "reference/employees/list-employees", title: "List Employees" },
  { sourcePath: "reference/employees/create-employee.md", routePath: "reference/employees/create-employee", title: "Create Employee" },
  { sourcePath: "reference/employees/update-employee.md", routePath: "reference/employees/update-employee", title: "Update Employee" },
  { sourcePath: "reference/companies/get-company.md", routePath: "reference/companies/get-company", title: "Get Company" },
  { sourcePath: "reference/companies/update-company.md", routePath: "reference/companies/update-company", title: "Update Company" },
  { sourcePath: "reference/payroll/create-payroll-run.md", routePath: "reference/payroll/create-payroll-run", title: "Create Payroll Run" },
  { sourcePath: "reference/payroll/process-payroll-run.md", routePath: "reference/payroll/process-payroll-run", title: "Process Payroll Run" },
  { sourcePath: "reference/payroll/finalize-payroll-run.md", routePath: "reference/payroll/finalize-payroll-run", title: "Finalize Payroll Run" },
  { sourcePath: "reference/payroll/get-accounting-breakdown.md", routePath: "reference/payroll/get-accounting-breakdown", title: "Get Accounting Breakdown" },
  { sourcePath: "reference/payroll/erp-journal-preview.md", routePath: "reference/payroll/erp-journal-preview", title: "ERP Journal Preview" },
  { sourcePath: "reference/payroll/erp-journal-sync.md", routePath: "reference/payroll/erp-journal-sync", title: "ERP Journal Sync" },
];

export const cimmplePayDocsByRoute = new Map(
  cimmplePayDocsManifest.map((item) => [item.routePath, item])
);

export const cimmplePaySidebarGroups: Array<{ label: string; items: CimmplePayDocItem[] }> = [
  {
    label: "Guides",
    items: cimmplePayDocsManifest.filter((d) => !d.sourcePath.startsWith("reference/")),
  },
  {
    label: "Reference",
    items: cimmplePayDocsManifest.filter((d) => d.sourcePath.startsWith("reference/")),
  },
];
